<template>
  <header class="cj-header">
    <div class="version" v-if="isDevEnv">v{{ version }}</div>

    <div class="container" v-if="!hideLogo">
      <div class="neon-logo off" />

      <div class="neon-logo on" v-if="!disabled" />
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CJHeader',

  props: {
    disabled: Boolean,
    hideLogo: Boolean,
  },

  $bus: {
    async 'age-confirmed' () {
      await this.$nextTick()

      const logo = this.$el.querySelector('.neon-logo.on')
      if (!logo) return

      logo.classList.add('flash')
      setTimeout(() => logo.classList.remove('flash'), 6000)
    },
  },

  computed: {
    ...mapGetters([ 'version', 'isDevEnv' ]),
  },
}
</script>

<style lang="stylus" scoped>
  header.cj-header
    > .version
      position: absolute
      top: 10px
      right: 34px
      color: gray
      font-weight: bold
      letter-spacing: 1px
      font-family: -apple-system, BlinkMacSystemFont, \
                   'Segoe UI', Roboto, Helvetica, Arial, sans-serif

      @media screen and (min-device-width: 1024px)
        right: 65px

    > .container
      position: relative

      > .neon-logo
        position: absolute
        top: 10px
        left: 50%
        transform: translateX(-50%)

        &.flash
          /*orlosneon animation: neon-flash-anim ease-in-out 5s*/
</style>
